import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const PurpleBlur = () => (
  <Box sx={{ 
    position: 'absolute',
    left: '-416.88px', 
    top: '242.23px',
    width: '901px',
    height: '984px',
    zIndex: 0,
  }}>
    <svg width="100%" height="100%" viewBox="0 0 901 984" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <g opacity="0.25" filter="url(#filter0_f_1052_266)">
        <path d="M423.987 486.6C294.378 432.738 308.979 407.633 236.005 357.526C163.03 307.42 26.7137 284.371 -35.46 320.247C-139.505 380.286 -144.666 447.292 -186.079 523.879C-224.331 594.62 -372.434 766.747 53.2772 785.233C478.988 803.72 585.999 553.927 423.987 486.6Z" fill="#BF6DFF"/>
      </g>
      <defs>
        <filter id="filter0_f_1052_266" x="-646.99" y="-101.997" width="1547.68" height="1293.03" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="202.414" result="effect1_foregroundBlur_1052_266"/>
        </filter>
      </defs>
    </svg>
  </Box>
);

const BlueBlur = () => (
  <Box sx={{ 
    position: 'absolute',
    left: '-416.93px', 
    top: '544.45px',
    width: '901px',
    height: '725px',
    zIndex: 0,
  }}>
    <svg width="100%" height="100%" viewBox="0 0 901 725" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <g opacity="0.25" filter="url(#filter0_f_1052_267)">
        <path d="M225.472 864.309C304.94 775.745 341.387 785.969 414.936 736.26C488.486 686.552 523.133 593.139 471.376 550.166C384.762 478.253 287.219 474.179 176.009 445.138C73.2883 418.315 -176.216 315.264 -206.508 607.414C-236.8 899.563 126.138 975.014 225.472 864.309Z" fill="#6DFCFF"/>
      </g>
      <defs>
        <filter id="filter0_f_1052_267" x="-613.127" y="0.748871" width="1514.05" height="1316.99" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="202.414" result="effect1_foregroundBlur_1052_267"/>
        </filter>
      </defs>
    </svg>
  </Box>
);

const ExpandIcon = () => (
  <Box sx={{ width: '24px', height: '24px', position: 'relative', overflow: 'hidden' }}>
    <Box sx={{ left: '2px', top: '2px', position: 'absolute' }}>
      <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 21.5C16.5228 21.5 21 17.0228 21 11.5C21 5.97715 16.5228 1.5 11 1.5C5.47715 1.5 1 5.97715 1 11.5C1 17.0228 5.47715 21.5 11 21.5Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </Box>
    <Box sx={{ left: '8px', top: '12px', position: 'absolute' }}>
      <svg width="10" height="3" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.5H9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </Box>
    <Box sx={{ left: '12px', top: '8px', position: 'absolute' }}>
      <svg width="2" height="11" viewBox="0 0 2 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1.5V9.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </Box>
  </Box>
);

interface FAQItemProps {
  question: string;
  answer: string;
}

const FAQItem: React.FC<FAQItemProps> = ({ question, answer }) => (
  <Box
    sx={{
      width: '100%',
      px: '55px',
      py: '35px',
      background: 'rgba(255, 255, 255, 0.10)',
      overflow: 'hidden',
      borderRadius: '10px',
      backdropFilter: 'blur(37.50px)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    }}
  >
    <Box sx={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', gap: '10px', flex: 1, marginRight: '20px' }}>
      <Typography sx={{ color: 'white', fontSize: '24px', fontFamily: 'Raleway', fontWeight: 700, lineHeight: '34px' }}>
        {question}
      </Typography>
      <Typography sx={{ color: 'white', fontSize: '18px', fontFamily: 'Raleway', fontWeight: 400, lineHeight: '28px' }}>
        {answer}
      </Typography>
    </Box>
    <ExpandIcon />
  </Box>
);

const FAQSection = () => {
  const faqItems = [
    {
      question: "What services does Alio offer?",
      answer: "Alio provides end-to-end technology solutions, including DevOps consulting, cloud infrastructure (AWS, Azure, GCP), CI/CD automation, QA testing (Katalon, Sonar), data engineering, and software development. We also offer Frontend development, UI/UX design, and infrastructure-as-code support to deliver full-stack experiences and scalable systems."
    },
    {
      question: "How does Alio help companies reduce cloud costs?",
      answer: "Our FinOps specialists analyze your cloud usage to find savings opportunities without compromising performance. Through automation, right-sizing, real-time dashboards, and reserved instance strategies, we help teams gain visibility and control over cloud spend."
    },
    {
      question: "Can Alio support my internal development team?",
      answer: "Yes. We often integrate with your Scrum teams to support everything from DevOps and QA automation to frontend engineering, data pipelines, and UX improvements. Our engineers adapt quickly to your workflows and bring niche expertise to accelerate delivery."
    },
    {
      question: "What industries does Alio typically work with?",
      answer: "We've partnered with clients in insurance, logistics, education, healthcare, and SaaS. Whether you need a scalable web app, improved cloud performance, or reliable data pipelines, we tailor our solutions to your industry's unique operational and regulatory needs."
    }
  ];

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        width: '100vw',
        minHeight: 'calc(100vh - 99px)',
        background: 'black',
        overflow: 'hidden',
        marginLeft: 'calc(-50vw + 50%)',
        marginRight: 'calc(-50vw + 50%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <PurpleBlur />
      <BlueBlur />
      
      <Container
        maxWidth={false}
        sx={{
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '25px',
          py: '151.23px',
          maxWidth: '1440px',
          pl: { xs: 2, sm: 3, md: 4 },
          pr: { xs: 2, sm: 3, md: '150px' },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            color: 'white',
            fontSize: '42px',
            fontFamily: 'Raleway',
            fontWeight: 600,
            width: '100%',
            mb: 2,
          }}
        >
          Frequently Asked Questions
        </Typography>
        
        <Box 
          sx={{ 
            width: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '25px',
            maxWidth: '1140px',
          }}
        >
          {faqItems.map((item, index) => (
            <FAQItem key={index} question={item.question} answer={item.answer} />
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQSection; 